/**
 * Retrieves the value of a specified cookie from the browser's `document.cookie`.
 */

export const getCookie = (name: string): string | null => {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);

	if (parts.length === 2) {
		const cookieValue = parts.pop()?.split(';')[0];
		return cookieValue || null;
	}
	return null;
};
